import {Action} from "redux";
import {IClientScoutCustomerActionCreator} from "../action/client_scout_customer_action";

import {
    CopyHighlightsByClientRequest,
    CreateClientBookmarkByClientRequest,
    CreateScoutCustomerByClientRequest,
    DeleteClientBookmarkByClientRequest,
    DeleteHighlightsByClientRequest,
    GetCustomerByClientRequest,
} from "../request/scout_request";

interface IClientScoutCustomerDispatcher {
    getCustomer(item: GetCustomerByClientRequest): void;

    createScoutCustomer(item: CreateScoutCustomerByClientRequest): void;

    createClientBookmark(item: CreateClientBookmarkByClientRequest): void;

    deleteClientBookmark(item: DeleteClientBookmarkByClientRequest): void;

    copyHighlights(item: CopyHighlightsByClientRequest): void;

    deleteHighlights(item: DeleteHighlightsByClientRequest): void;

}

class Dispatcher implements IClientScoutCustomerDispatcher {

    constructor(private dispatch: (action: Action) => void,
                private actionCreator: IClientScoutCustomerActionCreator) {

    }

    public getCustomer = (item: GetCustomerByClientRequest): void => {
        this.dispatch(this.actionCreator.requestGetCustomerAction(item));
    };

    public createScoutCustomer = (item: CreateScoutCustomerByClientRequest): void => {
        this.dispatch(this.actionCreator.requestCreateScoutCustomerAction(item));
    };

    public createClientBookmark = (item: CreateClientBookmarkByClientRequest): void => {
        this.dispatch(this.actionCreator.requestCreateClientBookmarkAction(item))
    };

    public deleteClientBookmark = (item: DeleteClientBookmarkByClientRequest): void => {
        this.dispatch(this.actionCreator.requestDeleteClientBookmarkAction(item))
    };

    public copyHighlights = (item: CopyHighlightsByClientRequest): void => {
        this.dispatch(this.actionCreator.requestCopyHighlightsAction(item))
    };

    public deleteHighlights = (item: DeleteHighlightsByClientRequest): void => {
        this.dispatch(this.actionCreator.requestDeleteHighlightsAction(item))
    }

}

const createScoutCustomerDispatcher = (dispatch: (action: Action) => void, actionCreator: IClientScoutCustomerActionCreator): IClientScoutCustomerDispatcher => {
    return new Dispatcher(dispatch, actionCreator);
};

export {IClientScoutCustomerDispatcher, createScoutCustomerDispatcher};



// WEBPACK FOOTER //
// ./src/presentation/dispatcher/client_scout_customer_dispatcher.ts